export function getStoredAccessToken() {
  try {
    return localStorage.getItem("base44_access_token") || localStorage.getItem("token") || "";
  } catch {
    return "";
  }
}

export function hasStoredAccessToken() {
  return Boolean(getStoredAccessToken());
}

export function clearStoredAccessToken() {
  try {
    localStorage.removeItem("base44_access_token");
    localStorage.removeItem("token");
  } catch {
    // Ignore storage restrictions.
  }
}